import React from 'react';
import {useTranslation} from 'react-i18next';

import TenantInfo from '../../components/TenantInfo';
import MoveInInfo from '../../components/MoveInInfo';

import './style.less'
import '../../style.less'

import {useHistory} from "react-router-dom";
import SendArrowIcon from "../../../svg/SendArrow";
import {usePlatform} from "../../../../context/PlatformContext";
import {resolveFoundOutAboutPlatform} from "../../../../utils/foundOutAboutPlatform";

const componentLabel = 'dashboard_list_item'

const PotentialTenantsDetails = ({user}) => {
    const {t, i18n} = useTranslation();
    const {platform} = usePlatform();

    let preferences = {...(user.preferences || user)};
    const foundOutEnabled = !!platform?.functionalities?.includes("how_did_you_hear_about_us");
    const foundOutLabel = foundOutEnabled
        ? resolveFoundOutAboutPlatform(user?.foundOutAboutPlatform, platform, i18n.language)
        : null;

    return (
        <div className={"PotentialTenantsDetails"}>
            {preferences?.accommodation &&
                <div>
                    <p className={'small'}>
                        <span>{t(componentLabel + '.looking_for')}</span> {t(`accommodation_type.${preferences.accommodation}`)}
                    </p>
                </div>}
            {preferences?.numRooms &&
                <div>
                    <p className={'small'}>
                        <span>{t(componentLabel + '.number_of_rooms')}</span> {`${preferences.numRooms} ${t('room', {count: preferences.numRooms})}`}
                    </p>
                </div>}
            {preferences?.location &&
                <div>
                    <p className={'small'}>
                        <span>{t(componentLabel + '.near_by')} </span>
                        {preferences.location === "none" ? t(componentLabel + '.locationNone') : (
                            preferences.location === "university" ? preferences?.university?.split('-')?.[0] : (
                                preferences.location === "metro" ? t(componentLabel + '.metro_lines.' + preferences.metro) : (
                                    preferences.neighborhood
                                )
                            )
                        )}
                    </p>
                </div>}
            {preferences?.city &&
                <div>
                    <p className={'small capitalize'}><span>{t(componentLabel + '.city')}</span> {preferences?.city}</p>
                </div>}
            {foundOutEnabled && (
                <div>
                    <p className={'small'}>
                        <span>{t('landlord.leads.found_out_about_us', 'How they found us')}: </span>
                        {foundOutLabel || '—'}
                    </p>
                </div>
            )}
        </div>)
}

const PotentialTenantsBudget = ({budget}) => {
    const {t} = useTranslation();

    return (
        <div className={"PotentialTenantsBudget"}>
            <p>{t(componentLabel + '.total_budget_label')}</p>
            {budget && <h4>{`${budget.from}€ - ${budget.to}€`}</h4>}
        </div>
    )
}

const Actions = (props) => {
    const {t} = useTranslation();
    const {tenant} = props;

    const history = useHistory();

    const openTenantDetails = (e) => {
        e.preventDefault();
        history.push(`/leads/${tenant.id}/details/`);
    }

    return (
        <div className={'Actions'}>
            <button className="btn btn-primary" onClick={(e) => props.handleClick(e, props.tenant)}>
                <SendArrowIcon/>
                {t(componentLabel + '.make_offer')}
            </button>
            <a href={`/leads/${tenant.id}/details/`}
               className="btn btn-secondary" onClick={openTenantDetails}>
                {t(componentLabel + '.viewMoreDetails')}
            </a>
        </div>
    )
}

const PotentialTenant = ({tenant, ...props}) => {

    const {t} = useTranslation();

    let preferences = {...(tenant.preferences || tenant)};

    return (
        <div
            className={"PotentialTenantContainer " + (preferences ? ' ListItem basic_container' : "") + ((tenant.availableProperties && tenant.availableProperties.length > 0) ? "" : " potentialTenant__noProperties")}>
            <div className={'ListItem__content'}>
                <TenantInfo listType={props.type} tenant={tenant} type={'fullIcon'} move_details={{
                    "move_in": preferences?.moveIn,
                    "move_out": preferences?.moveOut
                }}/>
                <PotentialTenantsDetails user={tenant}/>
                <MoveInInfo listType={props.type}
                            move_in={preferences?.moveIn}
                            move_out={preferences?.moveOut}
                            stayLength={preferences?.stayLength}
                />
                <PotentialTenantsBudget
                    budget={{from: preferences?.budgetMin, to: preferences?.budgetMax}}/>
                <Actions filter={props.filter} expires={preferences?.expires} tenant={tenant}
                         handleClick={props.handleClick} archive={props.archive} unarchive={props.unarchive}/>
            </div>
        </div>
    )

}

export default PotentialTenant;
